﻿import { GroupRole } from '../models/group-role';
import { User } from '../models/user';
import eventBus from '../services/event-bus';

export class UserDataStore { 
    static currentUser: User;
    
    static setCurrentUser(user: User) {
        UserDataStore.currentUser = user;
        eventBus.dispatch("userLoggedIn", { message: '' });
    }

    static getCurrentUser(): User {
       return UserDataStore.currentUser;
    }

    static isCurrentUserInRole(role: GroupRole) {
        let allowed = false;

        //if (role.roleCode) {
        if (UserDataStore.currentUser.roles && UserDataStore.currentUser.roles.includes(role))
            allowed = true;
        //}

        return allowed;
    }

    /* ORIG
    static isCurrentUserInRole(role: string) {
        let allowed = false;

        if (UserDataStore.currentUser.roles && UserDataStore.currentUser.roles.includes(role))
            allowed = true;

        return allowed;
    }
    */
}

